import React, { useState, useRef, useEffect } from 'react';

import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const ContactConcierge = ({ fromExperience = false, shadow = false, margin = "0" }) => {
    
    const REACT_APP_SITE_KEY = "process.env.REACT_APP_SITE_KEY";
    const captchaRef = useRef(null);

    const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 767px)").matches);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.matchMedia("(max-width: 767px)").matches);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const { t } = useTranslation();

    const [response, setResponse] = useState(null);
    const [fname, onChangeName] = useState("");
    const [lname, onChangeSurname] = useState("");
    const [email, onChangeEmail] = useState("");
    const [message, onChangeMessage] = useState("");
    const [phone, onChangePhone] = useState("");
    const [isAccepted, onClickTerms] = useState(false);
    const [isDisabled, onClickSend] = useState(false);

    useEffect(() => {
        if (response) {
            setTimeout(() => {
                setResponse(null);
            }, 5000);
        }
    }, [response]);

    const onClickHandeTerms = () => {
        if (isAccepted) {
            onClickTerms(false);
            onClickSend(false);
        } else {
            onClickTerms(true);
            onClickSend(true);
        }
    }

    const handleFormSubmit = e => {
        e.preventDefault();
        onClickSend(false);
        fetch(process.env.REACT_APP_SITE_URL + "PageBE/SendEmail", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                FirstName: fname,
                LastName: lname,
                Email: email,
                Phone: phone,
                Message: message,
                Accepted: isAccepted,
                FromExperience: fromExperience
              })
        })
        .then(async response => {
            if (response.ok) {
                setResponse({ message: t("SentOk"), success: true });
            } else {
                setResponse({ message: t("SentNotOk"), success: false });
            }
        })
    };

    return (
        <section>
            <div className={`background-white contactForm mb-5`} style={{ marginTop: margin }} id="contact-travel-designer">
                <div className={`container-fluid col-lg-9  ${shadow ? "shadow-custom" : ""}`}>
                    <div className="row">
                        <div className="col-md-12 col-12 pt-4 background-white">
                            <h1 className="mb-4 mt-5 text-center text-black title text-uppercase">{t("ContactTravelDesigners")}</h1>
                            <p className="paragraph text-center mb-0">{t("ContactTravelDesignersDescription1")}</p>
                            <p className="paragraph text-center">{t("ContactTravelDesignersDescription2")}</p>
                        </div>
                    </div>

                    <form action="#">
                        <div className="row justify-content-center inputField mt-3 mt-xs-5">
                            <div className="col-md-5 col-12">
                                <div className="form-floating">

                                    <input type="text" className="form-control" placeholder="First Name" value={fname} onChange={(x) => onChangeName(x.target.value)} required />
                                    <label htmlFor="fname">{t("FirstName")}*</label>
                                </div>
                            </div>
                            <div className="col-md-5 col-12">
                                <div className="form-floating">

                                    <input type="text" className="form-control" placeholder="Last Name" value={lname} onChange={(x) => onChangeSurname(x.target.value)} required />
                                    <label htmlFor="lname">{t("LastName")}*</label>
                                </div>
                            </div>

                            <div className="col-md-5 col-12">
                                <div className="form-floating">

                                    <input type="text" className="form-control" placeholder="Email" value={email} onChange={(x) => onChangeEmail(x.target.value)} required />
                                    <label htmlFor="email">{t("Email")}*</label>
                                </div>
                            </div>
                            <div className="col-md-5 col-12">
                                <div className="form-floating">

                                    <input type="text" className="form-control" placeholder="Phone Number" value={phone} onChange={(x) => onChangePhone(x.target.value)} />
                                    <label htmlFor="phone">{t("PhoneNumber")}</label>
                                </div>
                            </div>
                            <div className="col-md-10 col-12">
                                <div className="form-floating">

                                    <input type="text" className="form-control" placeholder="Message" value={message} onChange={(x) => onChangeMessage(x.target.value)} />
                                    <label htmlFor="message">{t("Message")}</label>
                                </div>
                            </div>
                            <div className="col-md-10 col-12 m-0 pe-0">
                                <p className="paragraph text-black m-0 d-flex">
                                    <input type="checkbox" className="m-0 me-2" value={isAccepted} onClick={(x) => onClickHandeTerms()} />
                                    <div className="mt-2 fs-14" dangerouslySetInnerHTML={{ __html: t("TermsConditionsHtml") }} />

                                </p>
                            </div>
                            <div className="col-md-10 col-12 text-right">
                                <div className="row">
                                <div className="col-md-12 col-12 textAlignMailSent"
                                dangerouslySetInnerHTML={{ __html: `${ response && response.message ? "<p>" + response.message + "</p>" : ""}` }} 
                                /> 
                                    <div className={`${isMobile ? "d-flex justify-content-center" : ""} col-md-12 col-12 pe-0 arrowEffectContainer`}><button onClick={e => handleFormSubmit(e)} className={"buttonSend  text-uppercase " + (!isMobile ? "mr-30 " : " ") + (!isDisabled ? "disabledSend" : "")}>{t("SendRequest")}<FontAwesomeIcon className="paddingArrow effectArrow" icon={faArrowRight} /></button></div>                                </div>
                                <div className="invisible">
                                    <ReCAPTCHA sitekey={REACT_APP_SITE_KEY} ref={captchaRef} />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    )
}

export default ContactConcierge;
